export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contraseña"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continuar"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingresa la contraseña de confirmación"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contraseña de confirmación"])}
}